<script>
    import { onMount, onDestroy } from 'svelte';
    import { translations, current_lang, festival_time } from '../../stores.js';
    import {check_time_diff_from_now_to_target} from '../../datetimefunctions.js';
    let timer_d;
    let timer_h;
    let timer_m;
    let timer_s;

    let timer_running = true;

    function updateTimer() {
        //countdown end time setting (counts to first concert of festival)
        let diff = check_time_diff_from_now_to_target($festival_time.start);

        if(diff <= 0){
            clearInterval(interval);
            timer_d = 0
            timer_h = 0;
            timer_m = 0;
            timer_s = 0;
            timer_running = false;
            return;
        }

        let days = Math.floor(diff / (1000 * 60 * 60 * 24));
        let hours = Math.floor(diff / (1000 * 60 * 60));
        let mins = Math.floor(diff / (1000 * 60));
        let secs = Math.floor(diff / 1000);

        timer_d = days;
        timer_h = hours - days * 24;
        timer_m = mins - hours * 60;
        timer_s = secs - mins * 60;
    }

    function festival_has_ended(){
        let diff_to_festival_end = check_time_diff_from_now_to_target($festival_time.end);
        if(diff_to_festival_end < 0){
            return true;
        }
        return false;
    }

    let interval;
    let festival_ended = false;

    onMount(async () => {
        festival_ended = festival_has_ended();
        updateTimer();
		interval = setInterval(updateTimer, 1000);
	});

    onDestroy(() => {
		clearInterval(interval);
	});
</script>
{#if festival_ended}
    {$translations["SEE_YOU_NEXT_YEAR"][$current_lang]} 
{:else}
    {#if timer_d != null && timer_h != null && timer_m != null && timer_s != null}
        <div><span style="font-size: 1.0rem;">{$translations["COUNTDOWN_TO_FESTIVAL"][$current_lang]}:</span></div>
        <div id="countdown-timer">
            <div><span>{timer_d} {$translations["TIME_DAYS"][$current_lang]}</span></div>
            <div><span>{timer_h} {$translations["TIME_HOURS"][$current_lang]}</span></div>
            <div><span>{timer_m} {$translations["TIME_MINUTES"][$current_lang]}</span></div>
            <div><span>{timer_s} {$translations["TIME_SECONDS"][$current_lang]}</span></div>
        </div>
    {/if}
{/if}


<style>
    #countdown-timer{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    #countdown-timer div:not(:first-of-type){
        margin-left: 10px;
    }
</style>